var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.5 6.2A3 3 0 0021.4 4c-1.9-.5-9.4-.5-9.4-.5s-7.5 0-9.4.5A3 3 0 00.5 6.3C0 8 0 12 0 12s0 4 .5 5.8A3 3 0 002.6 20c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 002.1-2c.5-2 .5-5.9.5-5.9s0-4-.5-5.8zm-14 9.4V8.4l6.3 3.6-6.3 3.6z"}));
}

Youtube.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Youtube;

Youtube.default = Youtube;
